import { getChartExpense } from '_services';
import { addPartCategory, editPartCategory, getGstTypeData, getMeasurementUnitList } from '_services/workShopServices/workShopServices';
import { CommonInput, CommonModal, CustomSelect } from 'components'
import { constant } from 'constants/constant';
import { errorSchema, utils } from 'helper';
import React, { useContext, useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import StorageService from 'utils/StorageServices';
import { FaYoutube } from 'react-icons/fa6';
import YoutubeModal from 'modals/YoutubeModal';
import { UserContext } from 'context';

const obj = {
    company_id: StorageService.getCompanyId(),
    name: "",
    account_to_reflect: {},
    gst_rate: {},
    hsn_code: "",
    unit: {},
    part_type: 1,
    inventory: 1,
    odometer_reading: 1,
    odometer_kms: '',
    time_interval: 1,
    time_interval_days: ''
}

const AddPartsCategory = (props) => {

    let { isOpen, closeModal = () => { }, callListApi = () => { }, getDataCallBack = () => { } } = props;
    const [formValue, setFormValue] = useState(obj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const { setModalZIndex, youtubeVideos, setYoutubeVideos } = useContext(UserContext);

    const [expenseList, setExpenseList] = useState([]);
    const [dataMeasurementUnit, setDataMeasurementUnit] = useState([]);
    const [gstTypeList, setGstTypeList] = useState([]);

    const handleOnChange = async (name, value) => {
        if (name === 'time_interval_days') {
            const num = Number(value);
            if (num > 365) {
                value = 365;
            } else if (num < 0) {
                value = '';
            }
        }
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditCategoryParts);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditCategoryParts);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async (shouldCloseModal = true) => {
        const toastId = "api-toast";
        try {
            if (isOpen?._id) {
                let object = {
                    ...formValue,
                    id: isOpen?._id,
                    company_id: StorageService.getCompanyId(),
                    gst_rate: formValue?.gst_rate?.value,
                    account_category: formValue?.account_to_reflect?.account_category,
                    account_sub_category: formValue?.account_to_reflect?.account_sub_category,
                    odometer_kms: formValue?.odometer_reading ? formValue?.odometer_kms : 0,
                    time_interval_days: formValue?.time_interval ? formValue?.time_interval_days : 0,
                    unit: {
                        name: formValue?.unit?.label,
                        id: formValue?.unit?.value
                    }
                }
                delete object.account_to_reflect;
                delete object._id;
                const res = await editPartCategory(object);
                if (res?.responseCode == 200) {
                    toast.success(res?.responseMessage, { id: toastId });
                    setFormValue({});
                    setLoading(false);
                    closeModal();
                    callListApi();
                } else {
                    setLoading(false);
                    toast.error(res?.responseMessage, { id: toastId });
                }
            } else {
                let object = {
                    ...formValue,
                    company_id: StorageService.getCompanyId(),
                    gst_rate: formValue?.gst_rate?.value,
                    account_category: formValue?.account_to_reflect?.account_category,
                    account_sub_category: formValue?.account_to_reflect?.account_sub_category,
                    odometer_kms: formValue?.odometer_reading ? formValue?.odometer_kms : 0,
                    time_interval_days: formValue?.time_interval ? formValue?.time_interval_days : 0,
                    unit: {
                        name: formValue?.unit?.label,
                        id: formValue?.unit?.value
                    }
                }
                delete object.account_to_reflect;
                const res = await addPartCategory(object);
                if (res?.responseCode == 200) {
                    getDataCallBack(res?.data);
                    toast.success(res?.responseMessage, { id: toastId });
                    setLoading(false);
                    setFormValue({});
                    closeModal();
                    callListApi();
                } else {
                    setLoading(false);
                    toast.error(res?.responseMessage, { id: toastId });
                }
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addEditCategoryParts);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            await apiCallingFunction(true);
            setFormError("");

        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    };

    const propsAddParts = {
        ...props,
        onSubmit: handleOnSubmit,
        isLoadding: loading,
        disabled: loading,
        showYouTubeIcon: false,
        youTubeOnClick: (e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'category_creation', moduleAction: true })),
    };

    const getExpenseHandler = async () => {
        try {
            const res = await getChartExpense({
                company_id: StorageService.getCompanyId(),
                category_id: 5,
                sub_category_id: 8,
            });

            if (res?.responseCode === 200) {
                const { category_id, sub_category_id } = res?.data;
                const details = res?.data?.categories?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?._id,
                        account_category: item?.type,
                        account_sub_category: item?.id,
                    };
                });

                // const updatedList = expenseArray.map((item) => ({
                //     ...item,
                //     category_id: category_id,
                //     sub_category_id: sub_category_id,
                // }));
                // if (!isEditDetails?.isEdit) {
                //     setExpenseArray(updatedList);
                // }
                setExpenseList(details);
            } else {
            }
        } catch (error) {
        }
    };

    const getMeasurementUnit = async () => {
        try {
            let object = { company_id: StorageService.getCompanyId() }
            const res = await getMeasurementUnitList();
            if (res?.responseCode === 200) {
                let array = res?.data?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })
                setDataMeasurementUnit(array);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
        }
    }
    const getGstTypeList = async () => {
        try {
            let object = { company_id: StorageService.getCompanyId() }
            const res = await getGstTypeData();
            if (res?.responseCode === 200) {
                let array = res?.data?.map((el) => {
                    return {
                        label: `${el?.perc} %`,
                        value: el?.id
                    }
                })
                setGstTypeList(array);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        if (isOpen?._id && expenseList?.length > 0 && gstTypeList?.length > 0) {
            let findObj = expenseList?.find((el) => el?.account_category === isOpen?.account_category && el?.account_sub_category === isOpen?.account_sub_category)
            let gstTypes = gstTypeList?.find((el) => el?.value === isOpen?.gst_rate);
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id,
                name: isOpen?.name,
                account_to_reflect: findObj,
                gst_rate: gstTypes,
                hsn_code: isOpen?.hsn_code,
                unit: { label: isOpen?.unit?.name, value: isOpen?.unit?.id },
                part_type: isOpen?.part_type,
                inventory: isOpen?.inventory,
                odometer_reading: isOpen?.odometer_reading,
                odometer_kms: isOpen?.odometer_kms > 0 ? isOpen?.odometer_kms : '',
                time_interval: isOpen?.time_interval,
                time_interval_days: isOpen?.time_interval_days > 0 ? isOpen?.time_interval_days : '',
            }))
        }
    }, [isOpen, expenseList, gstTypeList])

    useEffect(() => {
        getExpenseHandler();
        getMeasurementUnit();
        getGstTypeList();
    }, [])

    const youtubeProps = {
        isOpen: youtubeVideos,
        closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
        headerPart: false,
        modalTitle: `Add Part Category`,
        submitTitle: `Add Part Category`,
        modalMainClass: "_mdModal",
        videosModuleName: constant.Key.part_category,
    }

    return (
        <>
            <CommonModal {...propsAddParts}>
                <div className='__whAdd_item'>
                    <div className='singleDiv'>
                        <CommonInput
                            type="text"
                            placeholder="Part Category Name"
                            label="Part Category Name"
                            name='name'
                            value={formValue.name}
                            focus={!!(typeof formError === "object" && formError?.name)}
                            error={!!(typeof formError === "object") ? formError?.name : ""}
                            onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            maxLength="50"
                            onInput={utils.maxLengthCheck}
                            disabled={isOpen?.isDetails}
                        />
                    </div>

                    <div className='singleDiv'>
                        <CustomSelect
                            options={expenseList}
                            name="account_to_reflect"
                            flotingLabel="Account to Reflect*"
                            placeholder="Account to Reflect*"
                            value={formValue?.account_to_reflect}
                            error={formError["account_to_reflect.label"]}
                            onSelect={(data) => onhandleSelect(data, 'account_to_reflect')}
                            disabled={isOpen?.isDetails}
                        />
                    </div>

                    <div className='halfDiv'>
                        <CustomSelect
                            options={gstTypeList} // {constant.TaxPerct}
                            name="gst_rate"
                            flotingLabel="GST Rate"
                            placeholder="GST Rate"
                            value={formValue?.gst_rate}
                            disabled={isOpen?.isDetails}
                            error={formError["gst_rate.label"]}
                            onSelect={(data) => onhandleSelect(data, 'gst_rate')}
                        />
                    </div>

                    <div className='halfDiv'>
                        <CommonInput
                            type="text"
                            placeholder="HSN Code"
                            label="HSN Code"
                            disabled={isOpen?.isDetails}
                            name='hsn_code'
                            value={formValue.hsn_code}
                            focus={!!(typeof formError === "object" && formError?.hsn_code)}
                            error={!!(typeof formError === "object") ? formError?.hsn_code : ""}
                            onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                            maxLength="6"
                            onInput={utils.maxLengthCheck}
                        />
                    </div>

                    <div className='singleDiv'>
                        <CustomSelect
                            options={dataMeasurementUnit}
                            name="unit"
                            disabled={isOpen?.isDetails}
                            flotingLabel="Measurement Unit*"
                            placeholder="Pieces / Box/ Ltr/ Unit / KG*"
                            value={formValue?.unit}
                            error={formError["unit.label"]}
                            onSelect={(data) => onhandleSelect(data, 'unit')}
                        />
                    </div>

                    <div className='checkBx_lv mt-0 p-0 ' style={{ width: '100%' }}>
                        {
                            constant.itemPartsTypes?.map((el, ind) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <div className='_dualCheckr_bx'
                                            style={{ width: '50%' }}
                                        >
                                            <input
                                                style={{ marginTop: '2px' }}
                                                className="form-check-input"
                                                id={+ind + "part_type" + el?.value}
                                                type="radio"
                                                name="part_type"
                                                disabled={isOpen?.isDetails}
                                                checked={Number(formValue?.part_type) === Number(el?.value)}
                                                value={formValue?.part_type ? formValue?.part_type : ""}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, el?.value)
                                                }
                                            />
                                            <label style={{ fontSize: '14px', width: 'calc(100% - 22px)' }} htmlFor={+ind + "part_type" + el?.value} className="form-check-label" >
                                                {el.label}
                                                <p style={{ fontSize: '10px', color: '#000', opacity: '0.8', margin: '0px' }}>{el.bottomPara}</p>
                                            </label>
                                        </div>
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>

                    <div className='singleDiv mt-1 __sigCheckBx' style={{ flexWrap: 'wrap', gap: '6px' }}>
                        <h6>Inventory Manage</h6>

                        <div className='singleDiv  __halfCheckBx'>
                            <span>Manage Inventory</span>
                            <div className="_anvSwitcherNew form-check form-switch" >
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="inventory"
                                    disabled={isOpen?.isDetails}
                                    id="inventory"
                                    checked={formValue?.inventory}
                                    onChange={(e) => handleOnChange('inventory', e.target.checked ? 1 : 0)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='singleDiv mt-1 __sigCheckBx' style={{ marginBottom: '-6px' }}>
                        <h6>Service Reminders</h6>
                    </div>

                    <div className='singleDiv  __halfCheckBx'>
                        <span>Odometer Reading</span>
                        <div className="_anvSwitcherNew form-check form-switch" >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="odometer_reading"
                                disabled={isOpen?.isDetails}
                                checked={formValue?.odometer_reading}
                                onChange={(e) => handleOnChange('odometer_reading', e.target.checked ? 1 : 0)}
                            />
                        </div>
                    </div>
                    {
                        formValue?.odometer_reading ?
                            <div className='singleDiv __disBladeFlex'>
                                <CommonInput
                                    type="text"
                                    placeholder="Select Default Number of KM’s"
                                    name='odometer_kms'
                                    label="Select Default Number of KM’s"
                                    maxLength="6"
                                    disabled={isOpen?.isDetails}
                                    onInput={utils.maxLengthCheck}
                                    value={formValue.odometer_kms}
                                    focus={!!(typeof formError === "object" && formError?.odometer_kms)}
                                    error={!!(typeof formError === "object") ? formError?.odometer_kms : ""}
                                    onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                                />
                                <span className={formError?.odometer_kms ? '__flFloat __errorFlt' : '__flFloat'}>KMs</span>
                            </div>
                            : <></>
                    }

                    <div className='singleDiv  __halfCheckBx'>
                        <span>On Time Interval</span>
                        <div className="_anvSwitcherNew form-check form-switch" >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="time_interval"
                                disabled={isOpen?.isDetails}
                                checked={formValue?.time_interval}
                                onChange={(e) => handleOnChange('time_interval', e.target.checked ? 1 : 0)}
                            />
                        </div>
                    </div>

                    {formValue?.time_interval ?
                        <div className='singleDiv __disBladeFlex'>
                            <CommonInput
                                type="text"
                                placeholder="Select Default Number of Days"
                                name='time_interval_days'
                                label="Select Default Number of Days"
                                maxLength="3"
                                disabled={isOpen?.isDetails}
                                onInput={utils.maxLengthCheck}
                                value={formValue.time_interval_days}
                                focus={!!(typeof formError === "object" && formError?.time_interval_days)}
                                error={!!(typeof formError === "object") ? formError?.time_interval_days : ""}
                                onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                            />
                            <span className={formError?.time_interval_days ? '__flFloat __errorFlt' : '__flFloat'}>Days</span>
                        </div>
                        :
                        <></>
                    }
                </div>
            </CommonModal>
            {
                (youtubeVideos?.moduleName === 'category_creation' && youtubeVideos?.moduleAction === true)
                && (
                    <YoutubeModal {...youtubeProps} />
                )
            }
        </>
    )
}

export default AddPartsCategory